import Button from '@material-ui/core/Button';
import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles(
  (theme) => createStyles({
    contentHeaderBtn: {
      marginLeft: theme.spacing(2)
    },
    widgetWrapper: {
      "& > *:first-child": {
        width: "100%",
        height: "100%"
      }
    }
  })
);
const CustomHomepageButtons = (props) => {
  const {
    editMode,
    numWidgets,
    clearLayout,
    setAddWidgetDialogOpen,
    changeEditMode,
    defaultConfigAvailable,
    restoreDefault
  } = props;
  const styles = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !editMode && numWidgets > 0 ? /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      color: "primary",
      onClick: () => changeEditMode(true),
      size: "small",
      startIcon: /* @__PURE__ */ React.createElement(EditIcon, null)
    },
    "Edit"
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, defaultConfigAvailable && /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      className: styles.contentHeaderBtn,
      onClick: restoreDefault,
      size: "small",
      startIcon: /* @__PURE__ */ React.createElement(CancelIcon, null)
    },
    "Restore defaults"
  ), numWidgets > 0 && /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      color: "secondary",
      className: styles.contentHeaderBtn,
      onClick: clearLayout,
      size: "small",
      startIcon: /* @__PURE__ */ React.createElement(DeleteIcon, null)
    },
    "Clear all"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "contained",
      className: styles.contentHeaderBtn,
      onClick: () => setAddWidgetDialogOpen(true),
      size: "small",
      startIcon: /* @__PURE__ */ React.createElement(AddIcon, null)
    },
    "Add widget"
  ), numWidgets > 0 && /* @__PURE__ */ React.createElement(
    Button,
    {
      className: styles.contentHeaderBtn,
      variant: "contained",
      color: "primary",
      onClick: () => changeEditMode(false),
      size: "small",
      startIcon: /* @__PURE__ */ React.createElement(SaveIcon, null)
    },
    "Save"
  )));
};

export { CustomHomepageButtons };
//# sourceMappingURL=CustomHomepageButtons.esm.js.map
